const TutorVoiceStatus = {
    IDLE: "IDLE",
    SPEAKING: "SPEAKING",
    THINKING: "THINKING",
    LIMIT_REACHED: "LIMIT_REACHED",
}

export default TutorVoiceStatus
